<template>
  <el-dialog
    :visible="visible"
    :close-on-click-modal="false"
    :before-close="close"
    :modal-append-to-body="false"
    width="720px"
    :title="$t('Audience_Segment_Disable_Confirm_Title')"
  >
    <div class="disable-dialog-content">
      <el-alert
        type="warning"
        show-icon
        :closable="false"
        class="disable-dialog-alert"
      >
        <template slot="title">
          <span>
            {{ $t('Audience_Segment_Disable_Dialog_Intro_Prefix') }}
            <strong>"{{ segment.title }}"</strong
            >{{ $t('Audience_Segment_Disable_Dialog_Intro_Suffix') }}
          </span>
        </template>
      </el-alert>

      <p class="disable-dialog-effects-heading">
        {{ $t('Audience_Segment_Disable_Dialog_Effects_Heading') }}
      </p>
      <ul class="disable-dialog-effects-list">
        <li>
          {{ $t('Audience_Segment_Disable_Dialog_Effect_StopEvaluations') }}
        </li>
        <li>
          {{ $t('Audience_Segment_Disable_Dialog_Effect_StopDestinations') }}
        </li>
        <li>{{ $t('Audience_Segment_Disable_Dialog_Effect_KeepConfig') }}</li>
      </ul>

      <template v-if="campaigns && campaigns.length">
        <div class="disable-dialog-deps">
          <div class="disable-dialog-deps-header">
            <i class="el-icon-warning-outline" />
            <span>
              {{
                $tc(
                  'Audience_Segment_Disable_Dialog_Deps_Header',
                  campaigns.length,
                  { count: campaigns.length }
                )
              }}
            </span>
          </div>
          <p class="disable-dialog-deps-description">
            {{ $t('Audience_Segment_Disable_Dialog_Deps_Description') }}
          </p>
          <ul class="disable-dialog-deps-list">
            <li
              v-for="campaign in campaigns"
              :key="campaign.id"
              class="disable-dialog-deps-item"
            >
              <i class="el-icon-s-promotion" />
              <a
                :href="campaignOverviewHref(campaign)"
                target="_blank"
                rel="noopener"
                class="disable-dialog-deps-item-title"
                :title="$t('Audience_Segment_Disable_Dialog_Deps_OpenCampaign')"
                :data-qa="`disable-segment-dep-link-${campaign.id}`"
              >
                {{ campaign.title }}
                <i class="el-icon-top-right disable-dialog-deps-item-icon" />
              </a>
            </li>
          </ul>
        </div>
      </template>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="close" data-qa="disable-segment-cancel-button">
        {{ $t('Campaign_Dialog_Button_Cancel') }}
      </el-button>
      <el-button
        type="danger"
        :loading="loading"
        @click="confirm"
        data-qa="disable-segment-confirm-button"
      >
        {{ $t('Audience_Segment_Disable_Confirm_Button') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { projectRoute } from '@/core/helpers'

export default {
  name: 'DisableRollingSegmentDialog',

  props: {
    segment: {
      type: Object,
      required: true
    },
    campaigns: {
      type: Array,
      default: () => []
    },
    visible: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    close() {
      this.$emit('close')
    },

    confirm() {
      this.$emit('disable')
    },

    // Resolve to a URL string so target="_blank" opens without navigating the modal's parent.
    campaignOverviewHref(campaign) {
      const route = projectRoute({
        name: 'ViewCampaign',
        query: { id: campaign.id }
      })
      return this.$router.resolve(route).href
    }
  }
}
</script>

<style scoped>
.disable-dialog-content {
  text-align: left;
}

.disable-dialog-alert {
  margin-bottom: 16px;
}

.disable-dialog-alert >>> .el-alert__title {
  font-size: 14px;
  line-height: 1.5;
}

.disable-dialog-effects-heading {
  font-weight: 600;
  margin: 0 0 8px;
}

.disable-dialog-effects-list {
  margin: 0 0 16px;
  padding-left: 20px;
}

.disable-dialog-effects-list li {
  margin-bottom: 4px;
  color: #606266;
}

.disable-dialog-deps {
  background: #fdf6ec;
  border: 1px solid #f5dab1;
  border-radius: 4px;
  padding: 12px 16px;
}

.disable-dialog-deps-header {
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 600;
  color: #b88230;
  margin-bottom: 6px;
}

.disable-dialog-deps-header i {
  font-size: 18px;
}

.disable-dialog-deps-description {
  margin: 0 0 10px;
  color: #7c5a1f;
  font-size: 13px;
}

.disable-dialog-deps-list {
  list-style: none;
  margin: 0;
  padding: 0;
  max-height: 180px;
  overflow-y: auto;
}

.disable-dialog-deps-item {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #ffffff;
  border: 1px solid #f5dab1;
  border-radius: 3px;
  padding: 6px 10px;
  margin-bottom: 6px;
}

.disable-dialog-deps-item:last-child {
  margin-bottom: 0;
}

.disable-dialog-deps-item i {
  color: #b88230;
}

.disable-dialog-deps-item-title {
  font-weight: 500;
  color: #409eff;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  flex: 1;
  min-width: 0;
  word-break: break-word;
}

.disable-dialog-deps-item-title:hover,
.disable-dialog-deps-item-title:focus {
  color: #66b1ff;
  text-decoration: underline;
}

.disable-dialog-deps-item-icon {
  font-size: 12px;
  opacity: 0.7;
  flex-shrink: 0;
}
</style>



// WEBPACK FOOTER //
// src/modules/audiences/components/DisableRollingSegmentDialog.vue